<template>
  <div class="mt-1 w-100" style="overflow: hidden;background-color:#FAFAFA;">
    <div class="d-flex" style="overflow-x: auto;">
      <div v-for="(menu, index) in listMenu" :key="index">
        <el-tag v-if="showMenu(menu.val)"
                @click="handleSelectMenu(menu.val)"
                v-bind:style="menu.val == activeMenu ? activeMenuStyle : normalMenuStyle"
                effect="dark"
                style="height:40px "
                class="pointer text-center pt-1 px-3 mx-2 my-2 fw-bold font-size-14"
        >
          {{ menu.label }}
        </el-tag>
      </div>
    </div>
    <div style="border-top: solid #EEE 2px;" class="m-2" />
    <ZaloAccount v-if="activeMenu == 1" />
    <TagSetting v-if="activeMenu == 2" />
    <ImageLibrary v-if="activeMenu == 4" />
    <QuickReply v-if="activeMenu ===3" />
    <SyncData v-if="activeMenu===5" />
    <UserEmployee v-if="activeMenu===6" />
    <CharacterFilter v-if="activeMenu===7" />
  </div>
</template>

<script>
import ZaloAccount from "@/components/ZaloAccount";
import TagSetting from "../components/TagSetting.vue";
import QuickReply from "../components/QuickReply";
import ImageLibrary from "../components/ImageLibrary";
import SyncData from "../components/SyncData";
import UserEmployee from "../components/UserEmployee";
import CharacterFilter from "../components/CharacterFilter/CharacterFilter";

export default {
  components: {
    CharacterFilter,
    UserEmployee,
    SyncData,
    ZaloAccount,
    ImageLibrary,
    TagSetting,
    QuickReply
  },
  data() {
    return {
      activeMenu: "1",
      listMenu: [
        { label: "Liên kết tài khoản", val: 1 },
        { label: "Quản lý thẻ", val: 2 },
        { label: "Quản lý nhân viên", val: 6 },
        { label: "Tin nhắn mẫu", val: 3 },
        { label: "Thư viện hình ảnh", val: 4 },
        { label: "Lọc từ khóa cấm", val: 7 },
        // { label: "Salework Cloud", val: 8 },
        { label: "Đồng bộ dữ liệu", val: 5 },
        // { label: "Salework Contact", val: 9 },

      ]
    };
  },
  computed: {
    activeMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#0A58C0",
        "background-color": this.setTransparencyHex("#0A58C0", 0.08),
        margin: "1px 4px 3px 1px"
      };
    },
    normalMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#696B72",
        "background-color": "transparent",
        margin: "1px 4px 3px 1px"
      };
    }
  },
  methods: {
    showMenu(val) {
      if (val != 6 || this.isEmployeeManageUser()) {
        return true;
      }
      return false;
    },
    handleSelectMenu(key) {
      this.activeMenu = key;
    }
  },
  mounted() {
    if (!this.isAdminUser()) {
      this.$router.push("/conversation");
    }

    if (this.$route.hash === "#spam") {
      this.activeMenu = 6;
    } else if (this.$route.hash === "#tag") {
      this.activeMenu = 2;
    } else if (this.$route.hash === "#quick-messages") {
      this.activeMenu = 3;
    } else if (this.$route.hash === "#library") {
      this.activeMenu = 4;
    } else if (this.$route.hash === "#after-sale") {
      this.activeMenu = 5;
    } else if (this.$route.hash === "#message-list") {
      this.activeMenu = 7;
    }
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #6d6d6d;
}
</style>
